export default __webpack_public_path__ + "static/media/wdscheduler_screenshot.54a2e250.jpg";